import { combineReducers } from 'redux';
import { log } from './log/log.reducer';
import { results } from './results/results.reducer';

export const dailyTest = combineReducers({
    results,
    log
});
